<template>
  <div>
    <header-applis titre="Connaître votre projet" index-progression-courante="1"/>
    <div class="wrapper__content">
      <a :href="informationsParcours.diplomeChoisi.urlConsultation" target="_blank">
        <div class="content--confirmation app-votre-projet">
          <h5>{{ informationsParcours.diplomeChoisi.intituleLong }}</h5>
          <parcours :parcours-list="informationsParcours.diplomeChoisi.parcours"/>
        </div>
      </a>
      <div>
        <p>Je confirme que :</p>
        <ul>
          <li>ce diplôme et/ou cette formation correspond à ce que je vise ;</li>
          <li>j’ai pris connaissance des conditions d’admission et des compétences visées.</li>
        </ul>
      </div>
    </div>
    <footer-applis ecran-precedent="choixprojet" ecran-suivant="qualificationexperiencediplome" label-suivant="Je confirme et je passe à la suite"/>
  </div>
</template>

<script>
import HeaderApplis from '../components/HeaderApplis';
import FooterApplis from '../components/FooterApplis';
import Parcours from '../components/Parcours';

export default {
  name: 'confirmation',
  components: {
    Parcours,
    FooterApplis,
    HeaderApplis
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    }
  }
}
</script>

<style scoped>
.content--confirmation {
  border: solid #002e5d;
  margin-bottom: 1vh;
  padding: 5px;
}

.app-votre-projet {
  border: none;
  border-bottom: 1px solid lightgrey;
  text-align: initial;
  background-color: #f9f9f9;
  padding: .8rem 1rem;
  cursor: pointer;
}
</style>
